// KakaoTalk's in-app browser keeps its own sign-in, apart from the phone's
// browser, and cannot always record. Asked through its own scheme, KakaoTalk
// opens a link in the phone's browser (iOS and Android).
// A challenge link, or one of the new 챌린지 program's (/today and below).
const CHALLENGES = /^\/(challenges(-next)?|today)(\/|$)/;

export const inKakao = (ua = navigator.userAgent) => /KAKAOTALK/i.test(ua || '');
export const externalUrl = (href = window.location.href) => `kakaotalk://web/openExternal?url=${encodeURIComponent(href)}`;

/** Where to hand this visit, or '' to stay: a challenge (or /today) link, inside KakaoTalk, opened by someone not signed in there. */
export function handoffFor({ ua, path, href, signedIn }) {
  return inKakao(ua) && CHALLENGES.test(path || '') && !signedIn ? externalUrl(href) : '';
}

/**
 * Called once at start. The link is read now, before the router sends a
 * signed-out visit elsewhere; the sign-in state when Firebase first has it.
 * Reads auth and changes nothing in it.
 */
export function handOffSignedOut(auth, loc = window.location) {
  const visit = { ua: navigator.userAgent, path: loc.pathname, href: loc.href };
  if (!handoffFor({ ...visit, signedIn: false })) return;
  let asked = false;
  auth.onAuthStateChanged((user) => {
    if (asked) return;
    asked = true;
    const to = handoffFor({ ...visit, signedIn: !!user });
    if (to) window.location.href = to;
  });
}
